/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 13:52:54
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-28 10:01:32
 */
const parentRouter = [
  {
    label: '供应商信息管理',
    path: ''
  }
]
const routes = [
  {
    path: '/information/query',
    name: 'query',
    meta: {
      icon: 'icon-a-Property1gongyingshangzonglan',
      title: '已入库供应商查询',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/informationManage/views/Query.vue')
  },
  {
    path: '/information/repository',
    name: 'repository',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '供应商储备库',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/informationManage/views/Repository.vue')
  },
  // {
  //   path: '',
  //   name: 'portrait',
  //   meta: {
  //     icon: '.icon-a-Property1gongyingshangyaoqing-1',
  //     title: '供应商画像',
  //     keepAlive: true,
  //     parentTitle: parentRouter
  //   }
  // },
  {
    path: '/information/portrait/all',
    name: 'all',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '行业整体画像',
      keepAlive: true,
      // parentTitle: parentRouter,
      parentTitle: [...parentRouter, { label: '供应商画像', path: '' }]
    },
    component: () => import('@main/modules/informationManage/views/All.vue')
  },
  {
    path: '/information/portrait/one',
    name: 'one',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '单供应商画像',
      keepAlive: true,
      // parentTitle: parentRouter,
      parentTitle: [...parentRouter, { label: '供应商画像', path: '' }]
    },
    component: () => import('@main/modules/informationManage/views/One.vue')
  },
]
export default routes
